"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_dnd_1 = require("react-dnd");
const react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
const typography_1 = require("@components/typography");
const common_1 = require("@components/common");
const Link_1 = require("@components/buttons/Link");
const Apply_1 = __importDefault(require("./actions/Apply"));
const StartExercising_1 = __importDefault(require("./actions/StartExercising"));
const ExerciseSection_1 = __importDefault(require("./components/ExerciseSection"));
const Search_1 = __importDefault(require("./components/Search"));
const useLoadExercises_1 = require("@hooks/useLoadExercises");
const useIPOC_1 = require("./hooks/useIPOC");
const ExerciseTagList_1 = __importDefault(require("./components/ExerciseTagList"));
const Exercises_1 = require("@app/routes/IPOCPage/components/Exercises");
const CategoryWrap_1 = require("@app/routes/IPOCPage/components/CategoryWrap");
const classnames_1 = __importDefault(require("classnames"));
const styled_components_1 = __importDefault(require("styled-components"));
const AddButton = styled_components_1.default.button `
    padding: 10px 20px;
    background-color: #6a5acd; 
    color: white;
    border: none;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
        background-color: #5a4dbd;
    }

    &:active {
        background-color: #483a9b; 
    }

    &:focus {
        outline: none;
    }
`;
let t;
// @ts-ignore
if (typeof translation === "undefined")
    t = {
        ipoc: "IPOC",
        selectedTagsTitle: "Selected Exercises",
        showMore: "Show more",
        showLess: "Show less",
        apply: "Apply",
        startExercising: "Start Exercising",
        resetAll: "Reset all",
        searchPlaceholder: "Search by exercise",
        applying: "Applying...",
    };
// @ts-ignore
else
    t = translation === null || translation === void 0 ? void 0 : translation.ipoc;
const IPOCPage = () => {
    var _a;
    const { tags, changeTags, reset } = (0, useIPOC_1.useIPOC)();
    const exercises = (0, useLoadExercises_1.useLoadExercises)();
    const [search, setSearch] = (0, react_1.useState)("");
    const [isOpenedPopUp, setIsOpenedPopUp] = (0, react_1.useState)(false);
    const chooseExercise = (exercise) => {
        changeTags((tags) => tags.concat(exercise));
    };
    const removeExercise = (slug) => {
        changeTags((tags) => tags.filter((e) => e.id !== slug));
    };
    const handleSearch = (newSearch) => setSearch(newSearch.value);
    (0, react_1.useLayoutEffect)(() => {
        window.document.title = "IPOC";
    }, []);
    const processCategory = (object, currentSlug) => {
        const children = (object) => {
            if (object.exercises.length !== 0) {
                if (object.children.length !== 0) {
                    const categoriesAndExercises = object.children.map((category) => {
                        return processCategory(category, currentSlug);
                    });
                    categoriesAndExercises.push(processExercises(object.exercises, true, currentSlug));
                    return categoriesAndExercises;
                }
                return processExercises(object.exercises, false, currentSlug);
            }
            else if (object.children.length !== 0) {
                return object.children.map((category) => {
                    return processCategory(category, currentSlug);
                });
            }
        };
        return (react_1.default.createElement(common_1.Accordion, { key: object.slug, title: object.title, isFramed: true, open: !!search, hasExercises: object.exercises.length !== 0 && object.children.length === 0 }, children(object)));
    };
    const processExercises = (exercises, spread = false, currentSlug) => {
        // todo: удалить это после починки бека
        const name = (tag) => { var _a, _b; return (_b = (_a = tag.exercise_translation) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : tag.exercise_translation[0].name; };
        const filteredExercises = search
            ? exercises === null || exercises === void 0 ? void 0 : exercises.filter((exercise) => name(exercise).toLowerCase().includes(search === null || search === void 0 ? void 0 : search.toLowerCase())).map((exercise) => (Object.assign(Object.assign({}, exercise), { currentSlug })))
            : exercises === null || exercises === void 0 ? void 0 : exercises.map((exercise) => (Object.assign(Object.assign({}, exercise), { currentSlug })));
        if (search && filteredExercises.length === 0)
            return null;
        return (react_1.default.createElement(common_1.Flex, { justify: "space-between", className: (0, classnames_1.default)({ "non-empty": filteredExercises.length !== 0 }, { spread: spread }, "exercises-wrap") },
            react_1.default.createElement(Exercises_1.Exercises, { exercises: filteredExercises, groupSlug: "groupSlug", chooseExercise: chooseExercise, removeExercise: removeExercise, selectedTags: tags, t: t })));
    };
    const sections = Object.keys(exercises).map((group) => {
        const children = () => {
            if (exercises[group].exercises.length !== 0) {
                if (exercises[group].categories.length !== 0) {
                    const framed = exercises[group].slug === "sound";
                    const custom = exercises[group].slug === "speech" || exercises[group].slug === "slogovaya_structure";
                    return (react_1.default.createElement(CategoryWrap_1.CategoryWrap, { className: framed && !custom ? "framed" : custom ? 'speech' : "default" },
                        exercises[group].categories.map((category) => processCategory(category, exercises[group].slug)),
                        processExercises(exercises[group].exercises, true, exercises[group].slug)));
                }
                return processExercises(exercises[group].exercises, false, exercises[group].slug);
            }
            else if (exercises[group].categories.length !== 0) {
                // todo: тут еще добавить чек, нет ли упражнений
                const framed = (exercises[group].slug === "sound");
                const customClass = (exercises[group].slug === "speech");
                return (react_1.default.createElement(CategoryWrap_1.CategoryWrap, { className: framed && !customClass ? "framed" : customClass ? 'speech' : "default" }, exercises[group].categories.map((category) => processCategory(category, exercises[group].slug))));
            }
        };
        return (react_1.default.createElement(ExerciseSection_1.default, { key: exercises[group].slug, title: exercises[group].description }, children()));
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(common_1.Plate, null,
            react_1.default.createElement(typography_1.H1, null, t.ipoc),
            react_1.default.createElement(common_1.Box, { m: "20px 0" },
                react_1.default.createElement(typography_1.H3, null, t.selectedTagsTitle)),
            react_1.default.createElement(react_dnd_1.DndProvider, { backend: react_dnd_html5_backend_1.HTML5Backend },
                react_1.default.createElement(ExerciseTagList_1.default, { setTags: changeTags, tags: tags })),
            !!tags.length && (react_1.default.createElement(common_1.Box, { m: "20px 0" },
                react_1.default.createElement(Link_1.Link, { onClick: reset }, t.resetAll))),
            react_1.default.createElement(common_1.Box, { mt: "20px", w: "100%" },
                react_1.default.createElement(Search_1.default, { onSearch: handleSearch, t: t })),
            sections,
            react_1.default.createElement(common_1.Flex, null,
                react_1.default.createElement(common_1.Box, { mr: "20px" },
                    react_1.default.createElement(Apply_1.default, { selectedTags: tags, t: t })),
                react_1.default.createElement(StartExercising_1.default, { slugExercise: (_a = tags[0]) === null || _a === void 0 ? void 0 : _a.id, t: t })))));
};
exports.default = IPOCPage;
